import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=67dad9d1"
import script from "./materials.vue?vue&type=script&lang=js"
export * from "./materials.vue?vue&type=script&lang=js"
import style0 from "./materials.vue?vue&type=style&index=0&id=67dad9d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports